import React from 'react';
import {action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from './s';
import './product.scss';
import ProductHeader from './components/product-header';
import DocSize from './components/doc-size';
import GradYear from './components/grad-year';
import Moulding from './components/moulding/moulding';
import Mat from './components/mat/mat';
import ProductRender from './rendering/render';
import Glass from './components/glass';
import DescMain from './components/description-main/desc-main';
import SliderTH from './components/slider/slider-th';
import SliderTH_FR from './components/slider/slider-th-framerly';
import SliderRealImages from './components/slider/slider-real-images';
import Yotpo from './components/yotpo';
import ATC from './components/atc/atc';
import Category from './components/category';
import EngravedPlate from './components/engraved-plates/engraved-plate';
import Lino from './components/lino/lino';
import Insignia from './components/insignia/insignia';
import QtyComponent from './components/qty';
import CustomFieldsComponent from './components/customfields';
import CAFDocSize from './components/caf-doc-size';
import ModalSimple from '../global/modal-simple';
import ProductProcessing from './components/prod-processing';
import ProductShipping from './components/product-shipping';
import RelatedProducts from './components/related-products/related-products';
import * as emitter from '../global/emitter';
import AbTestStore from '../global/store/ab-test.store';
import LevelLockModal from './components/modals/level-lock.modal';
import ReturnPolicyModal from '../checkout/components/modals/return-policy.modal';
import ShareIcon from './components/share-icon';
import InfoIcon from './components/shared/info-icon';
import DescMainContent from './components/description-main/desc-main-content';
import {Header} from './components/framerly/header';
import ImageUpload from './components/image-upload/image-upload';
import {RenderDoubleStack} from './rendering/double-stack/render-double-stack';
import EngravedPlateExtended from './components/engraved-plates/ep-extended/engraved-plate-extended';
import {FrameBuilder} from '../renderV2/frame-builder/frame-builder';
import {currency, modal, Portal} from '../util';
import {EPMethod} from './rendering/render.def';

declare var __promo_json: IPromoObj;
declare var __fast_ship: boolean;
declare var __fast_ship_text: string;
declare var __normal_ship_text: string;
declare var __company_name: string;
declare var __domain_name: string;
declare var _msrp_red: boolean;

@observer
class ProductComponent extends React.Component {
    public state = {
        hasError: false,
    };

    constructor(props) {
        super(props);
        s.isRetail = true;
        makeObservable(this);
        window.react_product = this;
    }

    @action
    ab_update(_key: string, _value: number) {
        window.ab = window.ab || {};
        window.ab[_key] = _value;
        if (!AbTestStore.ab) {
            AbTestStore.ab = {};
        }
        AbTestStore.ab[_key] = _value;
        emitter.eventEmitter.dispatch(emitter.EventType.AB, 'ab');
        this.forceUpdate();
    }

    componentDidMount() {
        this.init();
    }

    init() {
        try {
            if (s.prod == undefined) {
                s.init();
            }

            const loadingDiv = document.getElementById('prod-loading') as HTMLDivElement;

            if (loadingDiv) {
                loadingDiv.remove();
            }
        } catch (err) {
            console.error(err);
            this.setState({hasError: true});
        }
    }

    toggleExpandable(e: React.KeyboardEvent<HTMLDivElement>, id: string) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const header = document.getElementById(id);

            if (header) {
                header.click();
            }
        }
    }

    render() {
        if (!s || !s.si) return null;

        if (this.state.hasError) {
            return <h2 className="text-center w-100">Sorry, this product could not be displayed at this time. Please try again later.</h2>;
        }

        return (
            <div>
                {s.ui.image_uploading && <ProductProcessing />}
                {!s.IsPortal3 && <ProductHeader />}
                <div id="prod-wrapper">
                    <div id="render">
                        {s.prod.ProductTypeID === 89 && <RenderDoubleStack pcs={s.pcs} />}
                        {s.prod.ProductTypeID !== 89 &&
                            s.ready &&
                            (s.RenderingV2 ? (
                                <FrameBuilder
                                    frame={s.frameV2}
                                    pcs={s.pcs}
                                />
                            ) : (
                                <ProductRender
                                    zoom={false}
                                    pcs={s.pcs}
                                    css={s.pcs.css}
                                />
                            ))}

                        {!s.ui.show_caf_doc_sizes && Portal?.PortalID !== 3 && (
                            <div id="prod-slider">
                                <SliderTH />
                            </div>
                        )}
                        {!s.ui.show_caf_doc_sizes && Portal?.PortalID === 3 && s.prod && (
                            <div id="prod-slider">
                                <SliderTH_FR />
                            </div>
                        )}
                        {!s.IsPortal3 && s.ui.allow_customer_photos && !s.ui.show_caf_doc_sizes && !s.ps.is_caf && window.innerWidth > 1200 && s.prod && s.prod.real_images && s.prod.real_images.length >= 3 && (
                            <div className="prod-real-images">
                                <hr style={{marginBottom: '0.5rem'}} />
                                <div
                                    style={{
                                        fontSize: '1.125rem',
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    Customer Photos
                                </div>
                                <div>Tag us and share your pics with #EarnItFrameIt</div>
                                <SliderRealImages />
                            </div>
                        )}
                    </div>
                    {!s.ui.show_caf_doc_sizes && (
                        <div id="cust">
                            {s.ui.is_bo && (
                                <div className="alert alert-danger mt-2">
                                    <div className="b">Backordered Product</div>
                                    {s.ui.bo_msg}
                                </div>
                            )}
                            {!s.IsPortal3 && window.innerWidth < 1200 && s.ui.show_pricing && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: '1rem',
                                        position: 'relative',
                                    }}
                                >
                                    <div style={{position: 'absolute', top: 0, right: 8}}>
                                        <ShareIcon />
                                    </div>

                                    {s.ui.show_pricing && s.ui.price !== s.ui.price_discount && (
                                        <div>
                                            <span className={_msrp_red ? `msrp-disc-mobile msrp-red` : `msrp-disc-mobile`}>{currency(s.ui.price_discount)}</span>
                                            <span className={`msrp-orig-mobile`}>
                                                <del>{currency(s.ui.price)}</del>
                                            </span>
                                        </div>
                                    )}
                                    {s.ui.show_pricing && s.ui.price === s.ui.price_discount && (
                                        <div>
                                            <span className={`msrp-disc-mobile`}>{currency(s.ui.price)}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                            {!s.IsPortal3 && <DocSize />}
                            {!s.IsPortal3 &&
                                s.prod &&
                                s.ui.categoryIds.map((m, i) => (
                                    <Category
                                        key={i}
                                        CategoryID={m}
                                    />
                                ))}

                            {!s.IsPortal3 && s.prod && (s.prod.CustomField1_Enabled || s.prod.CustomField2_Enabled || s.prod.CustomField3_Enabled) && <CustomFieldsComponent />}
                            {!s.IsPortal3 && s.prod && s.si && s.si.StoreTypeID !== 5 && (s.prod.allowUpload1 || s.prod.allowUpload2) && <ImageUpload />}
                            {!s.IsPortal3 && s.prod && s.prod.mouldings && s.prod.mouldings.length > 1 && <Moulding />}
                            {!s.IsPortal3 && <Mat />}
                            {!s.IsPortal3 && s.prod && s.prod.insignias && (s.prod.insignias.length > 1 || (s.prod.InsigniaID < 1 && s.prod.insignias.length > 0)) && <Insignia />}
                            {!s.IsPortal3 && s.prod && s.prod.EngravedPlateStatusID > 0 && s.prod.EPMethodID === EPMethod.Old && <EngravedPlate />}
                            {!s.IsPortal3 && s.prod && s.prod.EngravedPlateStatusID > 0 && s.prod.EPMethodID !== EPMethod.Old && <EngravedPlateExtended />}
                            {!s.IsPortal3 && ((s.prod && s.prod.linos && s.prod.linos.length > 1) || s.prod.ProductID === 88937) && <Lino />}
                            {!s.IsPortal3 && s.prod && s.si && s.si.StoreTypeID !== 5 && s.si.IsGlassAllowed && !s.prod.disableGlassUpgrades && <Glass />}

                            {s.prod && s.si && s.si.StoreProductMessage && s.si.StoreProductMessage.length > 0 && (
                                <div className="gray-box">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: s.si.StoreProductMessage,
                                        }}
                                    />
                                </div>
                            )}

                            {!s.IsPortal3 && s.ui.show_grad_year && <GradYear />}
                            {!s.IsPortal3 && ((s.ps.wholesale && s.prod && s.si && s.si.StoreTypeID !== 5) || (s.si.VolumeDiscounts && s.si.VolumeDiscounts.length > 0)) && <QtyComponent />}

                            {s.IsPortal3 && (
                                <div>
                                    <Header />
                                    <span style={{fontSize: '1.375rem', padding: '30px 0 20px', display: 'inline-block'}}>Features:</span>
                                    <DescMainContent />
                                </div>
                            )}

                            {s.ui.show_atc && <ATC />}

                            {s.isRetail && __promo_json.hasPromo && __promo_json.promo && __promo_json.promo.length > 0 && !(s.prod && s.si && s.si.StoreProductMessage && s.si.StoreProductMessage.length > 0) && (
                                <div>
                                    <ModalSimple
                                        id="modal-promo-code"
                                        title="Promo Code Terms"
                                    >
                                        <div>
                                            <ul>
                                                <li>
                                                    <div
                                                        className="ib"
                                                        dangerouslySetInnerHTML={{
                                                            __html: __promo_json.promo,
                                                        }}
                                                    ></div>
                                                </li>
                                            </ul>
                                            <hr></hr>
                                            {__promo_json.modal1 !== '' && (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: __promo_json.modal1,
                                                    }}
                                                ></div>
                                            )}
                                            {__promo_json.modal1 !== '' && <hr />}

                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: __promo_json.modal2,
                                                }}
                                            ></div>
                                        </div>
                                    </ModalSimple>
                                    <div className="discount-highlight-product-page">
                                        <div
                                            style={{display: 'inline'}}
                                            dangerouslySetInnerHTML={{
                                                __html: __promo_json.promo,
                                            }}
                                        ></div>
                                        <InfoIcon
                                            id="modal-promo-code"
                                            ariaLabel="Click here for more promotional information."
                                            useMargin={true}
                                            styleBlack={true}
                                        />
                                    </div>
                                </div>
                            )}

                            {__fast_ship && s.isRetail && s.si && s.si.StoreTypeID !== 5 && s.__fast_ship_orig && Portal?.PortalID !== 3 && (
                                <div className={`fast-ship-container`}>
                                    <div className="fast-ship">
                                        <i className="fas fa-shipping-fast"></i>
                                        <span>= SHIPS IN 2-3 DAYS</span>
                                    </div>
                                </div>
                            )}

                            {!s.IsPortal3 && !s.ps.is_caf && window.innerWidth <= 1200 && (
                                <div
                                    className="prod-real-images"
                                    style={{marginTop: '1.25rem'}}
                                >
                                    <div
                                        style={{
                                            fontSize: '1.125rem',
                                            fontWeight: 700,
                                            textTransform: 'uppercase',
                                        }}
                                    >
                                        Customer Photos
                                    </div>
                                    <div>Tag us and share your pics with #EarnItFrameIt</div>
                                    <SliderRealImages fullWidth={true} />
                                </div>
                            )}

                            {s.si && s.si.StoreTypeID === 5 && s.isRetail && (!s.si.StoreProductMessage || s.si.StoreProductMessage.length < 3) && (
                                <div className="text-center">
                                    <ModalSimple
                                        id="modal-linked"
                                        title="Store Information"
                                    >
                                        <div className="text-left">
                                            <p>
                                                {__company_name} is pleased to have established a partnership with {s.si.StoreName}. In an effort to fully support this organization, we refer all sales directly to them. Please support your {s.si.StoreName}, by placing your order using one of the
                                                methods below.
                                            </p>
                                            {s.si.Phone && s.si.Phone.length > 0 && (
                                                <p>
                                                    <b>You may place your order by</b>
                                                </p>
                                            )}
                                            {s.si.Phone && s.si.Phone.length > 0 && <p>Phone: {s.si.Phone}</p>}
                                            {s.si.Fax && s.si.Fax.length > 0 && <p>Fax: {s.si.Fax}</p>}
                                            {s.si.Address1 && s.si.Address1.length > 0 && (
                                                <p>
                                                    <b>Stop by the store</b>
                                                </p>
                                            )}
                                            {s.si.Address1 && s.si.Address1.length > 0 && <p>{s.si.Address1}</p>}
                                            {s.si.Address2 && s.si.Address2.length > 0 && <p>{s.si.Address2}</p>}
                                            {s.si.StoreLink && s.si.StoreLink.length > 0 && (
                                                <p>
                                                    <b>
                                                        For online ordering, please visit <a href={s.si.StoreLink}>{s.si.StoreName}</a>
                                                    </b>
                                                </p>
                                            )}
                                        </div>
                                    </ModalSimple>
                                    <button
                                        className="prod-atc-btn lg mt-4"
                                        onClick={() => modal('modal-linked')}
                                        aria-haspopup="dialog"
                                        aria-label="Learn how to buy"
                                        type="button"
                                    >
                                        Available In Store
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                    {s.prod && s.prod.IsCAF && s.ui.show_caf_doc_sizes && (
                        <div id="cust">
                            <CAFDocSize />
                        </div>
                    )}
                </div>
                {!s.ui.show_caf_doc_sizes && (
                    <div
                        style={{marginTop: '1rem'}}
                        id="prod-sections"
                    >
                        {!s.IsPortal3 && <DescMain toggleExpandable={this.toggleExpandable} />}
                        {!s.IsPortal3 && s.prod && s.prod.IsFrame && (
                            <div>
                                <div
                                    id="framing-instructions-container"
                                    className="prod-sub-header toggle-bs"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#framing-instructions"
                                    aria-expanded={false}
                                    aria-controls="framing-instructions"
                                    role="button"
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            // @ts-ignore
                                            document.getElementById('framing-instructions-container').click();
                                        }
                                    }}
                                    tabIndex={0}
                                >
                                    FRAMING &amp; HANGING INSTRUCTIONS
                                </div>
                                <div
                                    id="framing-instructions"
                                    className="collapse plh"
                                >
                                    Designed with easy-open backs, our frames include simple step-by-step instructions and archival-quality mounting materials for safely inserting your document.{' '}
                                    {s.prod && s.prod.LevelLock && !s.prod.HideLevelLock && (
                                        <span>
                                            Each frame is also shipped with our state-of-the-art <LevelLockModal /> to keep your frame straight and locked into place, ensuring professional results every time.
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                        {!s.IsPortal3 && (
                            <div>
                                <div
                                    id="return-policy-container"
                                    className="prod-sub-header toggle-bs"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#return-policy-prod"
                                    aria-expanded={false}
                                    aria-controls="return-policy-prod"
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={e => this.toggleExpandable(e, 'return-policy-container')}
                                >
                                    {Portal && Portal?.PortalID < 3 ? '120' : '30'}-day return policy
                                </div>
                                <div
                                    id="return-policy-prod"
                                    className="collapse plh"
                                >
                                    {Portal?.ProdReturnSnippet}
                                    <button
                                        className="link link-btn"
                                        onClick={() => modal('modal-return-policy')}
                                        aria-haspopup="dialog"
                                        aria-label="Return policy modal"
                                        type="button"
                                    >
                                        See our easy, {Portal && Portal?.PortalID < 3 ? '120' : '30'}-day return policy
                                    </button>
                                </div>
                            </div>
                        )}

                        {s.IsPortal3 && (
                            <div>
                                <div style={{fontWeight: 700}}></div>30-day return policy.{' '}
                                <a
                                    href="/return-policy"
                                    aria-label="Learn more about return policy"
                                >
                                    Learn more
                                </a>
                                .{' '}
                            </div>
                        )}

                        {false && <RelatedProducts />}

                        {!s.IsPortal3 && <ProductShipping />}

                        {s.ui.allow_reviews && <Yotpo toggleExpandable={this.toggleExpandable} />}

                        {s.prod && !s.prod.IsCAF && (
                            <div
                                className="row"
                                id="store-h2"
                            >
                                <div className="col-12 text-left">
                                    {s.si && s.si.H2_1 !== '' && s.si.H2_1_Content !== '' && (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: `<h2>${s.si.H2_1}</h2>${s.si.H2_1_Content}`,
                                            }}
                                        />
                                    )}
                                    {s.si && s.si.H2_2 !== '' && s.si.H2_2_Content !== '' && (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: `<h2>${s.si.H2_2}</h2>${s.si.H2_2_Content}`,
                                            }}
                                        />
                                    )}
                                    {s.si && s.si.H2_3 !== '' && s.si.H2_3_Content !== '' && (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: `<h2>${s.si.H2_3}</h2>${s.si.H2_3_Content}`,
                                            }}
                                        />
                                    )}
                                    {s.si && s.si.H2_4 !== '' && s.si.H2_4_Content !== '' && (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: `<h2>${s.si.H2_4}</h2>${s.si.H2_4_Content}`,
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <ModalSimple
                    id="modal-fast-ship-warning"
                    title="Fast Shipping Removed"
                >
                    <div className="text-left">
                        <p>If you customize this product it may not qualify for fast shipping.</p>
                        <div className="mt-2">
                            <span style={{paddingRight: 6}}>
                                <i className={Portal?.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`} />
                            </span>
                            Indicates the frame material that qualifies for Fast Shipping. If no icon, the product will ship with standard methods.
                        </div>
                    </div>
                </ModalSimple>
                <ModalSimple
                    id="modal-level-lock"
                    title="Level-Lock Frame Hanging System"
                >
                    <div>
                        <p>
                            The <strong>Level-Lock&reg; Hanging System</strong> is the ultimate solution for professionally hanging your framed documents, art, and wall decor with ease and precision. Included with every premium diploma frame or custom frame from Design Your Frame, Level-Lock&reg;
                            ensures your frames stay securely in place and perfectly straight. This innovative system eliminates the frustration of crooked or misaligned frames, giving you the confidence to create a polished and professional look every time.
                        </p>
                        <p>
                            Whether you’re showcasing a single diploma or creating a stunning gallery wall of awards, certificates, and artwork, Level-Lock&reg; makes it simple to align multiple frames and achieve an eye-catching arrangement. Each system comes with all the tools you need for
                            accurate, even hanging, so you can transform your home or office into a space that celebrates your achievements and personal style. With Level-Lock&reg;, hanging your frames is not just easier—it’s better!
                        </p>

                        <picture>
                            <source
                                srcSet="https://dfstatic.com/images/cached/general/levellockvideobutton.webp"
                                type="image/webp"
                            />
                            <img
                                className="resp"
                                src="https://dfstatic.com/images/cached/general/levellockvideobutton.jpg"
                                alt="level lock video button"
                            />
                        </picture>

                        <div style={{marginTop: '1rem'}}>
                            <a
                                href="/level-lock-hanging-system"
                                className="link underline"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="View level-lock frame hanging information"
                            >
                                Level-Lock Frame Hanging System
                            </a>
                        </div>
                    </div>
                </ModalSimple>
                <ReturnPolicyModal />
            </div>
        );
    }
}

export default ProductComponent;
